module.exports = "/assets/data/fda51597fe126755d0996e4f3cc22edc-NR25.data.json";